import _ from 'underscore';

import {
  SWITCH_CHECKOUT_ACTIVE_ITEM,
  GET_CURRENT_USER_FAILURE,
  GET_CURRENT_USER_SUCCESS,
  CLEAN_CHECKOUT_CONTENT_STORE,
  LOAD_CLIENT_BY_PLATE
} from './types';

const INITIAL_STATE = {
  activeKey: 'carData',
  currentUser: null,
  finishedLoad: false
};

export default function (state = INITIAL_STATE, action) {
  switch (action.type) {
    case SWITCH_CHECKOUT_ACTIVE_ITEM:
      return {
        ...state,
        activeKey: action.payload.content,
      };
    case GET_CURRENT_USER_FAILURE:
      return {
        ...state,
        currentUser: null
      };
    case GET_CURRENT_USER_SUCCESS:
      return {
        ...state,
        currentUser: action.payload.user
      }
    case CLEAN_CHECKOUT_CONTENT_STORE:
      let cleaned = {};
      _.each(action.payload.props, (p) => {
        cleaned[p] = INITIAL_STATE[p];
      });
      return {
        ...state,
        ...cleaned
      }
    case LOAD_CLIENT_BY_PLATE:
      return {
        ...state,
        currentUser: action.payload.currentUser,
        finishedLoad: action.payload.finishedLoad
      }
    default:
      return {
        ...state,
      };
  }
}



// WEBPACK FOOTER //
// ./src/workflow/checkout/checkoutContent/reducer.js